import { useState } from 'react';
import { contactInfo } from '@/mocks/homeData';

export default function ContactSection() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formMsg, setFormMsg] = useState('');

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('phone_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setFormStatus('success');
      setFormMsg('留言已发送，我们会尽快回复！');
      form.reset();
      return;
    }

    setFormStatus('success');
    setFormMsg('留言已发送，我们会尽快回复！');
    form.reset();
  };

  return (
    <section id="contact" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            {contactInfo.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-500">{contactInfo.subtitle}</p>
        </div>

        <div className="flex flex-col lg:flex-row gap-8 max-w-4xl mx-auto">
          <div className="flex-1">
            <p className="text-sm text-foreground-600 mb-6 leading-relaxed">{contactInfo.description}</p>
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-primary-600 w-4 h-4 flex items-center justify-center"></i>
                </div>
                <div>
                  <div className="text-xs text-foreground-500">电子邮箱</div>
                  <div className="text-sm font-medium text-foreground-800">{contactInfo.email}</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-wechat-line text-accent-600 w-4 h-4 flex items-center justify-center"></i>
                </div>
                <div>
                  <div className="text-xs text-foreground-500">微信公众号</div>
                  <div className="text-sm font-medium text-foreground-800">{contactInfo.wechat}</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-lg bg-secondary-200 flex items-center justify-center flex-shrink-0">
                  <i className="ri-group-line text-secondary-600 w-4 h-4 flex items-center justify-center"></i>
                </div>
                <div>
                  <div className="text-xs text-foreground-500">QQ交流群</div>
                  <div className="text-sm font-medium text-foreground-800">{contactInfo.qqGroup}</div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex-1">
            <form onSubmit={handleSubmit} className="bg-background-50 rounded-xl p-5 md:p-6 space-y-4" data-readdy-form="">
              <div>
                <label className="block text-sm font-medium text-foreground-700 mb-1.5">您的称呼</label>
                <input
                  type="text"
                  name="name"
                  required
                  className="w-full px-3 py-2.5 text-sm rounded-lg border border-secondary-200 bg-background-50 text-foreground-800 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 transition-colors"
                  placeholder="请输入您的称呼"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-foreground-700 mb-1.5">电子邮箱</label>
                <input
                  type="email"
                  name="email"
                  required
                  className="w-full px-3 py-2.5 text-sm rounded-lg border border-secondary-200 bg-background-50 text-foreground-800 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 transition-colors"
                  placeholder="请输入您的邮箱"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-foreground-700 mb-1.5">留言内容</label>
                <textarea
                  name="message"
                  required
                  maxLength={500}
                  rows={4}
                  className="w-full px-3 py-2.5 text-sm rounded-lg border border-secondary-200 bg-background-50 text-foreground-800 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                  placeholder="请输入您的留言内容（500字以内）"
                ></textarea>
              </div>
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="contact-spam-field"
              />
              <button
                type="submit"
                className="w-full py-2.5 text-sm font-semibold rounded-lg bg-primary-500 text-white hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                发送留言
              </button>
              {formStatus !== 'idle' && (
                <p className={`text-xs text-center ${formStatus === 'success' ? 'text-accent-600' : 'text-primary-600'}`}>
                  {formMsg}
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}